export default {"src":"/_next/static/media/carOutline100_40.3cf42bf2.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};